import { useEffect, useState } from "react";
import Button from "../../../../../../common/components/xepp/button/Button";
import styles from "./PaymentAmountForm.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../../stores/store";
import FieldPerSubtypePayment from "../FieldPerSubtypePayment/FieldPerSubtypePayment";
import { resetAllOptionAmounts, setAmount, setIsPaymentPerSubtype } from "../../../../../../stores/slices/service-type-slice";
import { Attribute, FieldType } from "../../../../../../model/service-request/attribute";
import { NumericFormat } from "react-number-format";

const PaymentAmountForm = () => {
    const dispatch = useDispatch();
    const currentState = useSelector((state: RootState) => state.serviceType);
    const [displayValue, setDisplayValue] = useState('0.00');

    const [selectedDropdown, setSelectedDropdown] = useState<Attribute | undefined>(
                                    currentState.sectionDefinitions
                                                .flatMap(section => section.attributeDefinitions)
                                                .find(field => field.childrenOptionDefinitions?.some(option => option.price))
    );

    const [isPerSubtype, setPerSubtype] = useState<boolean>(currentState.isPaymentPerSubtype);

    const handleChange = (values: any) => {
        dispatch(setAmount(values.floatValue))
    }



    const onYesClick = () => {
        setPerSubtype(true)
        dispatch(setAmount(undefined))
        dispatch(setIsPaymentPerSubtype(true))
    }


    return (
        <>
            {!isPerSubtype &&
                <div className={styles.wholePaymentContainer}>
                    <div className={styles.amountRow}>
                        <label>Enter Amount</label>
                        <div className={styles.amountInputContainer}>
                            <NumericFormat value={currentState.price?.amount}
                            onValueChange={handleChange}
                            thousandSeparator=","
                            decimalSeparator="."
                            decimalScale={2}
                            fixedDecimalScale
                            allowNegative={false}
                            className=""
                            placeholder="0.00"/>
                            {/* <input type="text" value={displayValue} onChange={handleChange} placeholder="0.00" /> */}
                            <span>NGN</span>
                        </div>
                    </div>

                    <div className={styles.perSubTypeQuestionContainer}>
                        <span>Do you want to apply price to sub type?</span>
                        <Button
                            text={'Yes'}
                            onClick={onYesClick}
                            variant={'outline'}
                        />
                    </div>
                </div>
            }

            {isPerSubtype &&
                <div className={styles.subtypesContainer}>
                    <div className={styles.perSubTypeContainer}>
                        {
                            currentState.sectionDefinitions.flatMap((section, sectionIndex) =>
                                section.attributeDefinitions.map((field, index) => {
                                    
                                return  field.fieldType == FieldType.Dropdown && field.isSingleType && <FieldPerSubtypePayment
                                    key={`${sectionIndex}-${index}`}
                                    field={field}
                                    fieldIndex={index}
                                    onDropdownClick={() => {
                                        setSelectedDropdown(field);
                                    }}
                                    isExpanded={field.id === selectedDropdown?.id}
                                    sectionIndex={sectionIndex}
                                />
                                })
                            )
                        }
                    </div>
                </div>
            }

        </>
    )
}

export default PaymentAmountForm;